import { GetBindPageQuery, GetBindPageQueryVariables } from '../gql/graphql';

import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_BIND_PAGE = graphql(`
  query getBindPage($submissionUuid: String, $quoteUuid: String) {
    binder: downloadFiles(
      documentInput: { submissionUuid: $submissionUuid, type: BINDER }
    ) {
      file
      fileUrl
      folderUrl
      result
    }
    quoteLetter: downloadFiles(
      documentInput: {
        submissionUuid: $submissionUuid
        quoteUuid: $quoteUuid
        type: QUOTE_LETTER
      }
    ) {
      file
      fileUrl
      folderUrl
      result
    }
    quotes(
      filters: {
        submissionUuid: $submissionUuid
        type: USER_QUOTE
        status: BOUND
      }
      sort: { order: "ASC", key: "order" }
    ) {
      pageInfo {
        totalResults
      }
      edges {
        cursor
        node {
          uuid
          referenceId
          createdAt
          updatedAt
          type
          name
          order
          quotedPremium
          selectedQuotedPremium
          limit
          retention
          ratedPremium
          technicalPremium
          modifiedCoveragePremium
          status
          excessConvergeQuotedPremium
          excessConvergeLimit
          excessConvergeAttachmentPoint
          subjectivities {
            edges {
              cursor
              node {
                uuid
                name
                type
                order
                afterPolicy
                quote {
                  uuid
                  attachments(filters: null, pagination: null, sort: null) {
                    edges {
                      cursor
                      node {
                        uuid
                        targetType
                        targetName
                        targetUuid
                        dataSource
                        filePath
                        createdAt
                        updatedAt
                        url
                      }
                    }
                  }
                  createdAt
                  included
                  deadline
                  isSatisfied
                  waived
                }
              }
            }
          }
          coverages(sort: { key: "order", order: "ASC" }) {
            edges {
              cursor
              node {
                uuid
                name
                type
                order
                score
                minScore
                maxScore
                createdAt
                updatedAt
                quote {
                  hazardGroup
                  basePremium
                  fusionScore
                  fusionScoreModifier
                  ratedFusionScoreModifier
                  selectedFusionScoreModifier
                  included
                  limit
                  modifiedCoveragePremium
                  restorationPeriodDays
                  retention
                  technicalPremium
                  uuid
                  waitingPeriodHours
                }
                controls {
                  edges {
                    cursor
                    node {
                      uuid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetBindPageQuery(variables: GetBindPageQueryVariables) {
  const { loading, error, data, refetch } = useQuery(GET_BIND_PAGE, {
    variables,
  });

  const info = useMemo(() => getInfo(variables, data), [data, variables]);

  return {
    error,
    loading,
    data,
    info,
    refetch,
  };
}

const getInfo = (
  variables: GetBindPageQueryVariables,
  data?: GetBindPageQuery
) => {
  const quote = getPaginatedNodes(data?.quotes).find(
    (quote) => variables.quoteUuid && quote.uuid === variables.quoteUuid
  );

  const subjectivities = getPaginatedNodes(quote?.subjectivities).filter(
    (e) => e.quote?.included === true
  );

  return {
    quote,
    subjectivities,
  };
};
